import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { customFormatters } from './customFormatters';
import lazyi18nextBackend from './lazyI18nextBackend';
import ReactPostprocessor from 'i18next-react-postprocessor';
/**
 * This is the default i18next config used by frontend projects
 *
 * You can provide either single resource or a map of ns to resources
 */ export default function i18n({ locale , resources , options ={}  }, debug) {
    const res = {
        [locale]: {
            translation: resources
        }
    };
    // Allow NS resources to be passed
    if (resources.translation) {
        res[locale] = resources;
    }
    return i18next.use(initReactI18next).use(lazyi18nextBackend()).use(new ReactPostprocessor()).use(customFormatters).init(_object_spread({
        partialBundledLanguages: true,
        keySeparator: '$',
        lng: locale,
        fallbackLng: 'en',
        debug,
        interpolation: {
            escapeValue: false
        },
        resources: res
    }, options), undefined);
}
